import { ForwardedRef, forwardRef } from "react";
import checkboxIcon from "assets/checkbox_icon.svg";
import { IconButtonWithTooltip } from "react-admin";

export enum MARK_TYPE {
  CHECKMARK = "checkmark",
  DASH = "dash"
}

interface ICheckboxProps {
  checked?: boolean;
  id: string;
  value: boolean;
  className?: string;
  disabled?: boolean;
  markType?: MARK_TYPE;
  cyId?: string;
  onChange: (field: string, value: any) => void;
  label?: string | JSX.Element;
  checkTopAlign?: boolean;
  errors?: Record<string, any>;
  touched?: Record<string, any>;
  withValidation?: boolean;
}

export const Checkbox = forwardRef<HTMLSpanElement, ICheckboxProps>(
  (props: ICheckboxProps, ref: ForwardedRef<HTMLSpanElement>): JSX.Element => {
    const {
      className = "",
      disabled,
      onChange,
      id,
      label,
      value,
      cyId = "",
      checkTopAlign = false,
      errors,
      touched,
      withValidation = false
    } = props;

    const error = touched && errors && touched[id] && errors[id];

    const handleOnchange = () => {
      if (disabled) return;
      onChange(id, !value);
    };

    return (
      <div className={className}>
        <div
          className={`flex -ml-2.5 ${
            checkTopAlign ? "items-start" : "items-center"
          } ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
        >
          <IconButtonWithTooltip
            data-cy={cyId}
            onClick={handleOnchange}
            disabled={disabled}
            label=""
          >
            <div className="w-6 h-6 flex justify-center items-center">
              <div
                className={`${
                  !value ? "border-2" : "border-none"
                } w-[20px] h-[20px] ${
                  error ? "border-error" : "border-[#5D5A57]"
                } rounded-sm`}
              >
                <img
                  className={`${
                    value ? "opacity-100" : "opacity-0"
                  } rounded-sm	bg-mono-primary transition-opacity ease-in-out duration-150`}
                  src={checkboxIcon}
                  alt="close icon"
                />
              </div>
            </div>
          </IconButtonWithTooltip>
          <input
            id={id}
            className="hidden"
            type="checkbox"
            checked={value}
            disabled={disabled}
            onChange={handleOnchange}
          />
          <label
            className={`ml-2.5 caption text-xs font-['Inter'] font-normal ${
              disabled ? "cursor-not-allowed" : "cursor-pointer"
            }`}
            htmlFor={id}
          >
            {label}
          </label>
        </div>
        {withValidation && (
          <p
            className="text-xs h-[16px] text-error font-['Inter'] ml-4 mt-[4px] !leading-4"
            data-cy={`${cyId}-error`}
          >
            {error}
          </p>
        )}
      </div>
    );
  }
);
